import React, { useEffect, useRef } from "react";
import { BOT_CONV_MESSAGE_TYPE } from "../../helpers/consts/common-consts";
import BotMessageFactory from "../question-ask/bot-message/bot-message-factory";

function lightenColor(color, percent) {
  let num = parseInt(color.replace("#", ""), 16),
      amt = Math.round(2.55 * percent),
      R = (num >> 16) + amt,
      G = (num >> 8 & 0x00FF) + amt,
      B = (num & 0x0000FF) + amt;
  
  return "#" + (
    0x1000000 +
    (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
    (B < 255 ? B < 1 ? 0 : B : 255)
  ).toString(16).slice(1).toUpperCase();
}

function ChatConversation(props) {
  const defaultBgColor = props.chatBotSetting?.headerBackgroundColor || '#f0f0f0';
  const defaultTextColor = props.chatBotSetting?.headerTextColor || '#000000';
  const messageEndRef = useRef(null);
  const ligtenBgColor = lightenColor(defaultBgColor, 5); // 20% lighter

  const scrollToBottom = () => {
    if (messageEndRef.current) {
      messageEndRef.current?.scrollIntoView({
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [props]);

  return (
    <div ref={messageEndRef}>
      {props.senderType === BOT_CONV_MESSAGE_TYPE ? (
        <div className="w-full flex items-end gap-2 my-2">
          <div className="bg-transparent flex-shrink-0 w-9 h-9 flex items-center justify-center">
            <img
              src={props.chatBotSetting.logo}
              alt="logo"
              className="w-full h-full object-cover"
            />
          </div>
          {/* 
          <div className="bg-gray-100 rounded-md p-4">
            <p className="text-gray-700 md:text-base text-sm">
              {props.message}
            </p>
          </div> 
          */}
          <BotMessageFactory {...props} />
        </div>
      ) : (
        <div className="w-full flex items-end justify-end my-2 gap-2">
          <div
            style={{
              backgroundColor: ligtenBgColor,
              color: defaultTextColor,
            }}

            className="rounded-md p-4">
            <p className="text-white md:text-base text-sm">{props.message}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default ChatConversation;
